import styles from "./pagination.module.css";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { Button } from "../index";
import { getVisiblePages } from "../../../lib/pagination-page";
const Pagination = ({
  currentPage,
  total,
  lastPage,
  per_page,
  handlePageChange = () => {},
}) => {
  const totalPages = lastPage || Math.ceil(total / per_page);

  const visiblePages = getVisiblePages(currentPage, totalPages);
  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.pagination}>
        <div className={styles.paginationContent}>
          <Button
            type="button"
            disabled={currentPage === 1}
            title={<FaAngleLeft size={20} />}
            style={styles.paginationButton}
            onHandler={() => handlePageChange(currentPage - 1)}
          />

          <div className={styles.total__pages}>
            {visiblePages.map((item, idx) =>
              item === "left-ellipsis" || item === "right-ellipsis" ? (
                <span key={item + idx} className={styles.ellipsis}>
                  ...
                </span>
              ) : (
                <button
                  key={"page-" + item}
                  className={`${styles.pageButton} ${
                    currentPage === item ? styles.activePage : ""
                  }`}
                  onClick={() => handlePageChange(item)}
                >
                  {item}
                </button>
              )
            )}
          </div>

          <Button
            type="button"
            disabled={currentPage >= totalPages}
            title={<FaAngleRight size={20} />}
            style={styles.paginationButton}
            onHandler={() => handlePageChange(currentPage + 1)}
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
